export class Coder {
    encode(rawObject: any) {
        return btoa(JSON.stringify(rawObject));
    }
    decode(encodedData: string) {
        return JSON.parse(atob(encodedData));
    }
};



// WEBPACK FOOTER //
// /build/~/tslint-loader!./services/Coder.ts